export default {
  play: '立即遊玩',
  fullscreen: '全螢幕模式',
  addToFavorites: '加入收藏',
  removeFromFavorites: '從收藏中移除',
  similarGames: '相似遊戲',
  howToPlay: '遊戲玩法',
  gameDescription: '遊戲描述',
  controlsAndInstructions: '操作說明',
  share: '分享',
  gameUnavailable: '遊戲暫時無法使用',
  tryAgainLater: '此遊戲目前無法使用，請稍後再試。',
  openInNewTab: '在新分頁中開啟',
  gameTitle: '遊戲標題',
  genres: '遊戲類型',
  tags: '標籤',
  noGenre: '無類型',
  noTags: '無標籤',
  new: '新遊戲',
  playAmazingGame: '立即體驗這款精彩遊戲！',
  noSimilarGames: '沒有相似遊戲',
  gameNotFound: '找不到遊戲',
  gameNotExistOrRemoved: '您搜尋的遊戲不存在或已被移除。',
  backToHome: '返回首頁',
  seoTitle: '{title} - 網上遊戲 - GoGameVault',
  seoTitleNotFound: '找不到遊戲 - GoGameVault',
  seoKeywords: '玩{title}，免費網上遊戲，{tags}遊戲',
  gameFeatures: '遊戲特色',
  controlDetails: '操作詳情'
}; 